import { Link, useLocation } from "react-router-dom";

interface BreadcrumbProps {
  items?: { label: string; to?: string }[];
}

const routeNameMap: Record<string, string> = {
  "": "首页",
  category: "分类",
  drama: "电视剧",
  action: "动作片",
  scifi: "科幻片",
  documentary: "纪录片",
  article: "详情",
  about: "关于我们",
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const autoBreadcrumbs = (() => {
    const segments = location.pathname.split("/").filter(Boolean);
    const crumbs: { label: string; to?: string }[] = [
      { label: "首页", to: "/" },
    ];

    let currentPath = "";
    segments.forEach((seg) => {
      currentPath += `/${seg}`;
      const label = routeNameMap[seg] || seg;
      crumbs.push({ label, to: currentPath });
    });

    return crumbs;
  })();

  const breadcrumbs = items || autoBreadcrumbs;

  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center gap-2 text-sm flex-wrap">
        {breadcrumbs.map((crumb, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {index === breadcrumbs.length - 1 ? (
              <span className="text-foreground-600">{crumb.label}</span>
            ) : crumb.to ? (
              <Link
                to={crumb.to}
                className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className="text-foreground-400">{crumb.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}